import axios from 'axios';
import { setAlert } from "./alert";

import { url } from '../utils/api';
import { ADD_FEEDBACK, FEEDBACK_ERROR, LOAD_FEEDBACK } from './types';

// Get feedbacks
export const getFeedbacks = () => async dispatch => {
      const config = {
          headers: {
              'Content-Type': 'application/json',
          }
      }
      try {
          const res = await axios.get(`${url}/api/feedbacks`, config);
  
          dispatch({
              type: LOAD_FEEDBACK,
              payload: res.data
          });
      } catch (err) {
          dispatch({
              type: FEEDBACK_ERROR,
              payload: { msg: err.response.statusText, status: err.response.status}
          });
      }
  }
  
// Add feedback
export const addFeedback = (formData) => async dispatch => {
      const config = {
          headers: {
              'Content-Type': 'application/json',
          }
      }
      try {
          const res = await axios.post(`${url}/api/feedbacks/add`, formData, config);
  
          dispatch({
              type: ADD_FEEDBACK,
              payload: res.data
          });
  
          dispatch(setAlert('Feedback Sent', 'success'));
      } catch (err) {
          dispatch(setAlert('Error sending feedback', 'danger'));
          dispatch({
              type: FEEDBACK_ERROR,
              payload: { msg: err.response.statusText, status: err.response.status}
          });
          
      }
}